import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import Header from '../components/Header';
import Footer from '../components/Footer';
import BackToTop from '../components/BackToTop';
import CustomCursor from '../components/CustomCursor';
import { Head } from 'vite-react-ssg';


const Products = () => {
  const [darkMode, setDarkMode] = useState(false);
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.05 });

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    document.documentElement.classList.toggle('dark');
  };

  const silk = [0.25, 0.46, 0.45, 0.94];
  const expo = [0.16, 1, 0.3, 1];

  // ── Events-style animation variants ──
  const eyebrowV = { hidden:{opacity:0,y:14}, visible:{opacity:1,y:0,transition:{duration:0.7,ease:silk}} };
  const wordV    = { hidden:{opacity:0,y:44,rotateX:14}, visible:{opacity:1,y:0,rotateX:0,transition:{duration:0.8,ease:expo}} };
  const italicV  = { hidden:{opacity:0,x:-36,skewX:-5}, visible:{opacity:1,x:0,skewX:0,transition:{duration:0.7,ease:expo}} };
  const cardV    = { hidden:{opacity:0,y:44,scale:0.97}, visible:{opacity:1,y:0,scale:1,transition:{duration:1.0,ease:expo}} };
  const idxNumV  = { hidden:{opacity:0,y:10}, visible:{opacity:1,y:0,transition:{duration:0.9,ease:silk}} };
  const idxLineV = { hidden:{scaleX:0,opacity:0}, visible:{scaleX:1,opacity:1,transition:{duration:1.1,ease:expo}} };
  const footHrLV = { hidden:{scaleX:0,opacity:0}, visible:{scaleX:1,opacity:1,transition:{duration:1.2,ease:expo}} };
  const footHrRV = { hidden:{scaleX:0,opacity:0}, visible:{scaleX:1,opacity:1,transition:{duration:1.2,ease:expo}} };
  const footLblV = { hidden:{opacity:0,y:6}, visible:{opacity:1,y:0,transition:{duration:1.0,ease:silk,delay:0.2}} };

  const products = [
    {
      title: 'iPulse',
      description: 'Fruit antioxidant fusion for energy & vitality',
      mrp: '3,097.50',
      route: '/products/ipulse',
      image: '/assest/ipulse.jpg',
    },
    {
      title: 'iCoffee',
      description: 'Ayurvedic coffee blend for blood sugar support',
      mrp: '3,097.50',
      route: '/products/icoffee',
      image: '/assest/icoffee.jpg',
    },
    {
      title: 'iSlim',
      description: 'Sustainable weight management solution',
      mrp: '3,097.50',
      route: '/products/islim',
      image: '/assest/islim.jpg',
    },
    {
      title: 'iGlow',
      description: 'Ingestible skincare for radiant beauty',
      mrp: '3,097.50',
      route: '/products/iglow',
      image: '/assest/iGlow.jpg',
    },
    {
      title: 'iCare',
      description: 'Complete cellular care & immune support',
      mrp: '3,097.50',
      route: '/products/icare',
      image: '/assest/iCare.jpg',
    },
    {
      title: 'iCharge',
      description: 'Energizing blend for enhanced performance',
      mrp: '3,097.50',
      route: '/products/icharge',
      image: '/assest/icharge.jpg',
    }
  ];

  return (
    <div className={darkMode ? 'dark' : ''}>
   
<Head>
  {/* ── Basic Meta ── */}
  <title>VibrantViva Products | Wellness, Nutrition and Lifestyle Solutions</title>
  <meta
    name="description"
    content="Explore VibrantViva products designed to support wellness, nutrition, and everyday lifestyle needs with quality solutions you can trust."
  />
  <meta
    name="keywords"
    content="VibrantViva Wellness Products, Nutrition Products, Health and Wellness Products, Lifestyle Products, Wellness Solutions, wellness solutions for healthy living, VibrantViva products, nutrition and wellness, healthy lifestyle products, quality wellness solutions, health products India"
  />
  <meta name="author" content="VibrantViva" />
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://vibrantviva.com/products" />

  {/* ── Open Graph (Facebook / WhatsApp / LinkedIn) ── */}
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://vibrantviva.com/products" />
  <meta
    property="og:title"
    content="VibrantViva Products | Wellness, Nutrition & Lifestyle Solutions"
  />
  <meta
    property="og:description"
    content="Explore VibrantViva products designed to support wellness, nutrition, and everyday lifestyle needs with quality solutions you can trust."
  />
  <meta property="og:image" content="https://vibrantviva.com/assest/logo.png" />
  <meta property="og:image:width" content="200" />
  <meta property="og:image:height" content="200" />
  <meta property="og:site_name" content="VibrantViva" />
  <meta property="og:locale" content="en_IN" />

  {/* ── JSON-LD Structured Data ── */}
  <script
  type="application/ld+json"
  dangerouslySetInnerHTML={{
    __html: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "VibrantViva",
      "url": "https://vibrantviva.com/products",
      "logo": "https://vibrantviva.com/logo.png",
      "description":
        "Explore VibrantViva products designed to support wellness, nutrition, and everyday lifestyle needs with quality solutions you can trust.",
      "sameAs": [
        "https://www.facebook.com/media/set/?vanity=officialVibrantViva&set=a.705168821617957",
        "https://www.instagram.com/vibrantvivaofficial/",
        "https://www.linkedin.com/company/indusviva-healthsciences-private-limited/posts/?feedView=all&viewAsMember=true",
        "https://x.com/IndusvivaPvt?t=yf_P18W0HW6DR9ZbrhjRzg&s=09",
        "https://www.youtube.com/@VibrantViva"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+91-1800-103-4916",
        "contactType": "Customer Support",
        "hoursAvailable": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday"
            ],
            "opens": "09:30",
            "closes": "18:00"
          },
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Saturday"],
            "opens": "09:30",
            "closes": "13:30"
          }
        ],
        "availableLanguage": [
          "English",
          "Hindi",
          "Kannada",
          "Tamil",
          "Telugu",
          "Malayalam"
        ],
        "areaServed": "IN",
        "contactOption": "TollFree"
      },
      "address": {
        "@type": "PostalAddress",
        "streetAddress":
          "No 92-1-36, Viva Tower, Nandi Durga Road, Jayamahal Extension",
        "addressLocality": "Bangalore Urban",
        "addressRegion": "Karnataka",
        "postalCode": "560046",
        "addressCountry": "IN"
      },
      "location": {
        "@type": "Place",
        "name": "Viva Tower",
        "address": {
          "@type": "PostalAddress",
          "streetAddress":
            "No 92-1-36, Viva Tower, Nandi Durga Road, Jayamahal Extension",
          "addressLocality": "Bangalore Urban",
          "addressRegion": "Karnataka",
          "postalCode": "560046",
          "addressCountry": "IN"
        }
      }
    })}
  }/>
</Head>

      <style dangerouslySetInnerHTML={{ __html: `
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400;1,500&family=Outfit:wght@300;400;500;600&display=swap');

        *, *::before, *::after { box-sizing: border-box; }

        .prod-root {
          font-family: 'Outfit', sans-serif;
          background: #F7F3EE;
          min-height: 100vh;
        }


        .prod-hero {
          background: #0F0A07;
          padding-bottom: 64px;
        }

        .prod-inner { position: relative; z-index: 1; }

        .section-eyebrow {
          font-family: 'Outfit', sans-serif; font-size: 0.6rem; font-weight: 500;
          letter-spacing: 0.3em; text-transform: uppercase; color: #B8926A;
          display: flex; align-items: center; gap: 12px;
        }
        .eyebrow-line { display: inline-block; width: 32px; height: 1px; background: #6B4226; }

        .heading-primary {
          font-family: 'Cormorant Garamond', serif; font-weight: 500;
          letter-spacing: -0.015em; line-height: 1.15; color: #F5ECD8; perspective: 700px;
        }
        .heading-italic {
          font-family: 'Cormorant Garamond', serif; font-style: italic;
          font-weight: 400; color: #C9956A; display: block; margin-top: 4px;
        }
        .heading-desc {
          font-family: 'Outfit', sans-serif;
          font-size: 0.82rem;
          font-weight: 300;
          color: rgba(245,236,216,0.7);
          line-height: 1.75;
          max-width: 380px;
          margin-top: 18px;
        }

        .prod-cards-section {
          background: #F7F3EE;
          padding: 64px 0 96px;
        }

        .index-num {
          font-family: 'Cormorant Garamond', serif; font-style: italic;
          font-size: 0.82rem; color: #B8926A;
        }
        .index-hr { flex: 1; height: 1px; background: rgba(139,74,42,0.15); transform-origin: left center; }

        .products-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 60px;
        }
        @media (max-width: 900px) { .products-grid { grid-template-columns: repeat(2, 1fr); } }
        @media (max-width: 560px) { .products-grid { grid-template-columns: 1fr; } }
        .products-grid > *:last-child:nth-child(3n - 2) { grid-column: 2; }

        .prod-card {
          position: relative;
          background: #111009;
          border: 1px solid rgba(180,140,100,0.12);
          border-radius: 18px;
          overflow: hidden;
          transition:
            border-color 0.5s ease,
            box-shadow 0.5s ease,
            transform 0.5s cubic-bezier(0.25,0.46,0.45,0.94);
        }
        .prod-card:hover {
          border-color: rgba(201,149,106,0.4);
          box-shadow:
            0 32px 72px rgba(15,10,7,0.18),
            0 8px 24px rgba(201,149,106,0.08);
          transform: translateY(-7px);
        }

        .prod-card::after {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0; height: 2px;
          background: linear-gradient(90deg, transparent, #C9956A, #E8C87A, #C9956A, transparent);
          opacity: 0;
          transition: opacity 0.5s ease;
          z-index: 3;
        }
        .prod-card:hover::after { opacity: 1; }

        .prod-img-wrap {
          position: relative;
          height: 268px;
          overflow: hidden;
          background: #1a1410;
        }
        .prod-img-wrap img {
          width: 100%; height: 100%; object-fit: cover;
          transition: transform 2.6s cubic-bezier(0.16,1,0.3,1), filter 0.6s ease;
          filter: brightness(1.13) saturate(1.05);
        }
        .prod-card:hover .prod-img-wrap img {
          transform: scale(1.06);
          filter: brightness(1.05) saturate(1.12);
        }
        .prod-img-overlay {
          position: absolute; inset: 0;
          background: linear-gradient(to bottom, transparent 55%, rgba(15,10,7,0.45) 100%);
        }
        .prod-img-shine {
          position: absolute; bottom: 0; left: 0; right: 0; height: 1px;
          background: linear-gradient(to right, transparent, rgba(201,149,106,0.55), transparent);
          opacity: 0; transition: opacity 0.5s ease;
        }
        .prod-card:hover .prod-img-shine { opacity: 1; }

        .prod-ghost-num {
          position: absolute; right: -4px; bottom: -16px;
          font-family: 'Cormorant Garamond', serif; font-style: italic;
          font-weight: 700; font-size: 5.5rem; line-height: 1;
          color: rgba(201,149,106,0.05); pointer-events: none; user-select: none; z-index: 1;
          transition: color 0.6s ease, transform 0.6s ease;
        }
        .prod-card:hover .prod-ghost-num {
          color: rgba(201,149,106,0.1);
          transform: translateY(-5px);
        }

        .prod-body { padding: 22px 24px 26px; position: relative; }

        .prod-title {
          font-family: 'Cormorant Garamond', serif; font-weight: 500;
          font-size: 1.5rem; letter-spacing: -0.02em; color: #F5ECD8;
          line-height: 1.1; margin-bottom: 8px;
          transition: color 0.4s ease;
        }
        .prod-card:hover .prod-title { color: #FAF0DA; }

        .prod-desc {
          font-family: 'Outfit', sans-serif; font-size: 0.82rem; font-weight: 400;
          color: #F5ECD8;
          line-height: 1.7; margin-bottom: 20px;
          transition: color 0.5s ease;
        }
        .prod-card:hover .prod-desc { color: rgba(200,160,110,0.75); }

        .prod-sep {
          height: 1px;
          background: linear-gradient(to right, rgba(201,149,106,0.18), transparent);
          margin-bottom: 20px;
        }

        .prod-footer { display: flex; align-items: center; justify-content: space-between; }

        .prod-price-label {
          font-family: 'Outfit', sans-serif; font-size: 0.6rem;
          letter-spacing: 0.22em; text-transform: uppercase;
          color: #F5ECD8; margin-bottom: 5px;
        }
        .prod-price {
          font-family: 'Outfit', sans-serif; font-size: 1.4rem;
          font-weight: 500; color: #F5ECD8; letter-spacing: -0.01em;
        }
        .prod-price span {
          font-family: 'Outfit', sans-serif; font-size: 0.75rem;
          font-weight: 400; color: #F5ECD8; margin-right: 2px;
        }

        .prod-cta {
          width: 42px; height: 42px; border-radius: 50%;
          border: 1px solid rgba(201,149,106,0.22);
          background: rgba(201,149,106,0.07);
          display: flex; align-items: center; justify-content: center;
          transition:
            transform 0.6s cubic-bezier(0.34,1.56,0.64,1),
            background 0.4s ease,
            border-color 0.4s ease,
            box-shadow 0.4s ease;
          text-decoration: none;
        }
        .prod-card:hover .prod-cta {
          transform: rotate(45deg);
          background: rgba(201,149,106,0.2);
          border-color: rgba(201,149,106,0.55);
          box-shadow: 0 0 18px rgba(201,149,106,0.18);
        }

        .section-divider {
          height: 1px;
          background: linear-gradient(to right, rgba(201,149,106,0.4), transparent);
        }

        .foot-hr { flex: 1; height: 1px; background: rgba(139,74,42,0.15); }
        .foot-hr-left  { transform-origin: left center; }
        .foot-hr-right { transform-origin: right center; }
        .foot-label {
          font-family: 'Outfit', sans-serif; font-size: 0.55rem;
          letter-spacing: 0.3em; text-transform: uppercase; color: #C9956A; opacity: 0.5;
        }
      `}} />

      <CustomCursor />

      <div className="prod-root">

        {/* ── Dark hero ── */}
        <div className="prod-hero">
      
            <Header darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
       

          <div ref={ref} className="container mx-auto px-6 max-w-6xl pt-28 pb-2">

            <div className="flex items-end gap-10" style={{ marginTop: '48px' }}>

              {/* Heading with Events-style word-by-word + italic slide */}
              <motion.h1
                className="heading-primary text-4xl md:text-5xl"
                variants={{ hidden:{}, visible:{ transition:{ staggerChildren:0.12, delayChildren:0.18 } } }}
                initial="hidden" animate={inView ? 'visible' : 'hidden'}
              >
                <span style={{ display:'flex', flexWrap:'wrap', gap:'0 0.3em' }}>
                  {['Know ', 'Your'].map((w) => (
                    <motion.span key={w} variants={wordV} style={{ display:'inline-block' }}>{w}</motion.span>
                  ))}
                </span>
                <motion.span className="heading-italic" variants={italicV}>Product</motion.span>
              </motion.h1>

              <motion.div
                style={{ width:1, alignSelf:'stretch', background:'linear-gradient(to bottom, transparent, rgba(201,149,106,0.4), transparent)', marginBottom:6 }}
                className="hidden md:block"
                initial={{ opacity:0, scaleY:0 }}
                animate={inView ? { opacity:1, scaleY:1 } : {}}
                transition={{ duration:0.7, ease:expo, delay:0.3 }}
              />

              {/* Desc para - desktop */}
              <motion.p
                className="heading-desc hidden md:block"
                variants={eyebrowV} initial="hidden" animate={inView ? 'visible' : 'hidden'}
              >
                Discover our curated collection of wellness products designed to energize your body, enhance your appearance, and support your overall well-being.
              </motion.p>
              {/* Desc para - mobile */}
              <motion.p
                className="heading-desc md:hidden"
                variants={eyebrowV} initial="hidden" animate={inView ? 'visible' : 'hidden'}
              >
                Discover our curated collection of wellness products designed to energize your body, enhance your appearance, and support your overall well-being.
              </motion.p>
            </div>

            <motion.div
              className="section-divider mt-10"
              initial={{ scaleX:0, opacity:0 }}
              animate={inView ? { scaleX:1, opacity:1 } : {}}
              transition={{ duration:1, ease:expo, delay:0.5 }}
              style={{ transformOrigin:'left' }}
            />
          </div>
        </div>

        {/* ── Light cards section ── */}
        <div className="prod-cards-section">
          <div className="container mx-auto px-6 max-w-6xl">

            <motion.div
              className="products-grid"
              variants={{ hidden:{}, visible:{ transition:{ staggerChildren:0.11, delayChildren:0.2 } } }}
              initial="hidden" animate={inView ? 'visible' : 'hidden'}
            >
              {products.map((product, index) => (
                <motion.div key={index} variants={cardV}>
                  <motion.div
                    className="flex items-center gap-3 mb-3"
                    variants={{ hidden:{}, visible:{ transition:{ staggerChildren:0.1 } } }}
                  >
                    <motion.span className="index-num" variants={idxNumV}>0{index + 1}</motion.span>
                    <motion.div className="index-hr" variants={idxLineV} />
                  </motion.div>

                  <div
                    className="prod-card"
                    style={{ cursor: 'pointer' }}
                    onClick={() => window.location.href = product.route}
                  >
                    <div className="prod-img-wrap">
                      <img
                        src={product.image}
                        alt={product.title}
                        onError={(e) => { e.target.src = `https://via.placeholder.com/400x300?text=${product.title}`; }}
                      />
                      <div className="prod-img-overlay" />
                      <div className="prod-img-shine" />
                    </div>

                    <div className="prod-body">
                      <div className="prod-ghost-num">0{index + 1}</div>
                      <h3 className="prod-title">{product.title}</h3>
                      <p className="prod-desc">{product.description}</p>
                      {/* <div className="prod-sep" />
                      <div className="prod-footer"> */}
                        {/* <div>
                          <p className="prod-price-label">MRP incl. all taxes</p>
                          <p className="prod-price"><span>₹</span>{product.mrp}</p>
                        </div> */}
                        {/* <Link to={product.route} className="prod-cta">
                          <ArrowUpRight size={16} color="#C9956A" strokeWidth={1.5} />
                        </Link> */}
                      {/* </div> */}
                    </div>
                  </div>
                </motion.div>
              ))}
            </motion.div>

            {/* ── Footer rule ── */}
            <motion.div
              className="mt-14 flex items-center gap-4"
              variants={{ hidden:{}, visible:{ transition:{ staggerChildren:0.08, delayChildren:1.2 } } }}
              initial="hidden" animate={inView ? 'visible' : 'hidden'}
            >
              <motion.div className="foot-hr foot-hr-left" variants={footHrLV} />
              <motion.span className="foot-label" variants={footLblV}>Select to explore</motion.span>
              <motion.div className="foot-hr foot-hr-right" variants={footHrRV} />
            </motion.div>

          </div>
        </div>

      </div>

      <Footer />
      <BackToTop />
    </div>
  );
};

export default Products;